import { type ReactNode } from 'react';

interface RouteProps {
  children: ReactNode;
  title?: string;
  description?: string;
}

const RouteWrapper = ({ children, title = 'ClearVPN', description }: RouteProps) => {
  return (
    <>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      {description ? (
        <>
          <meta name="description" content={description} />
          <meta property="og:description" content={description} />
        </>
      ) : null}
      {children}
    </>
  );
};

export default RouteWrapper;
